import React from 'react';

export default {
  path: '/fleet/info/:id',
  async action({ params }) {
    const { default: FleetInfo } = await import('./FleetInfo');
    return <FleetInfo key={'info'} contract={params.id} />;
  },
};
